import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledGoBackLink = styled.a`
  display: flex;
  align-items: center;
  color: ${theme.token.var('colors.green.a200')};
  font-weight: 600;
  font-size: ${theme.token.var('fontSizes.sm')};
  margin: 16px 0 20px 0;
  cursor: pointer;

  img {
    margin-right: 13px;

    @media (min-width: ${theme.token('breakpoints.lg')}) {
      width: 16px;
    }
  }
`
